import { useGetGlobalSearchResultsPresenter } from './useGetGlobalSearchResultsPresenter'
import { GlobalSearchModal } from '../../views/GlobalSearchModal/GlobalSearchModal'

interface IGetGlobalSearchResultsPresenterProps {
  isOpen: boolean
  onClose: () => void
}

export const GetGlobalSearchResultsPresenter = ({
  isOpen,
  onClose,
}: IGetGlobalSearchResultsPresenterProps) => {
  const {
    commands: {
      changeQuery,
      openHighlightedOrSubmit,
      openRecentItem,
      openResultItem,
      selectTab,
      navigateDown,
      navigateUp,
    },
    data: {
      query,
      recentItems,
      resultItems,
      tabs,
      inputRef,
      highlightedIndex,
      activeDescendantId,
      isExpanded,
    },
    states: {
      showEnterHint,
      contentState,
      selectedTab,
      showTruncatedNotice,
      noResultsMessage,
      unsupportedQueryMessage,
      errorMessage,
    },
  } = useGetGlobalSearchResultsPresenter(onClose)

  return (
    <GlobalSearchModal
      isOpen={isOpen}
      query={query}
      showEnterHint={showEnterHint}
      contentState={contentState}
      recentItems={recentItems}
      resultItems={resultItems}
      tabs={tabs}
      selectedTab={selectedTab}
      showTruncatedNotice={showTruncatedNotice}
      noResultsMessage={noResultsMessage}
      unsupportedQueryMessage={unsupportedQueryMessage}
      errorMessage={errorMessage}
      inputRef={inputRef}
      highlightedIndex={highlightedIndex}
      activeDescendantId={activeDescendantId}
      isExpanded={isExpanded}
      onClose={onClose}
      onQueryChange={changeQuery}
      onEnter={openHighlightedOrSubmit}
      onNavigateDown={navigateDown}
      onNavigateUp={navigateUp}
      onRecentItemClick={openRecentItem}
      onResultItemClick={openResultItem}
      onTabChange={selectTab}
    />
  )
}
